import { http } from '../../config/axios'

export default function getFaturaDownloadRegistro(id:string) :Promise<Blob>{
    return http.get('/api/fatura/imprimirregistro/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao getFaturaDownloadRegistro')
        return new Blob()
    })
}